(function () {
  if (window.__AWTireSetIntegrityWired) return;
  window.__AWTireSetIntegrityWired = true;

  var CHECKOUT_SELECTOR = [
    '[name="checkout"]',
    '[data-cart-checkout]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]'
  ].join(',');
  var REMOVE_SELECTOR = [
    'a[href*="/cart/change"][href*="quantity=0"]',
    'a[href*="/cart/change"][href*="quantity%3D0"]'
  ].join(',');
  var CART_EVENTS = [
    'cart:updated',
    'cart:refresh',
    'cartcount:update',
    'theme:cart:change',
    'cart-token-updated',
    'candyrack-offer-removed'
  ];
  var LEGACY_HANDLING_PRODUCTS = ['9802024386877', '10271704547645'];
  var inFlight = null;
  var scheduled = null;
  var resumingCheckout = false;

  function property(item, key) {
    if (!item || !item.properties) return '';
    return String(item.properties[key] || '');
  }

  function isTireSetItem(item) {
    return property(item, '_tsb') === 'true';
  }

  function legacyCategory(item) {
    if (LEGACY_HANDLING_PRODUCTS.indexOf(String(item.product_id)) !== -1) return 'handling';
    if (item.product_type === 'Tire') return 'tire';
    if (item.product_type === 'TPMS') return 'tpms';
    if (item.product_type === 'Wheels') return 'wheel';
    return '';
  }

  function groupItems(items) {
    return items.reduce(function (groups, item) {
      var bundleId = property(item, '_tsb_bundle_id') || '__legacy__';
      groups[bundleId] = groups[bundleId] || [];
      groups[bundleId].push(item);
      return groups;
    }, {});
  }

  function unique(values) {
    return values.filter(function (value, index) {
      return value && values.indexOf(value) === index;
    });
  }

  function isStructuredBundleComplete(items) {
    var required = [];
    items.forEach(function (item) {
      required = required.concat(
        property(item, '_tsb_required_components').split(',').map(function (value) {
          return value.trim();
        })
      );
    });
    required = unique(required);
    if (!required.length) return null;

    var components = {};
    var quantitiesMatch = true;
    items.forEach(function (item) {
      var component = property(item, '_tsb_component');
      var expectedQty = parseInt(property(item, '_tsb_expected_qty'), 10);
      if (component) components[component] = (components[component] || 0) + 1;
      if (!expectedQty || Number(item.quantity) !== expectedQty) quantitiesMatch = false;
    });

    return quantitiesMatch && required.every(function (component) {
      return components[component] === 1;
    });
  }

  function isLegacyBundleComplete(items) {
    var categories = {};
    items.forEach(function (item) {
      var category = legacyCategory(item);
      if (category) categories[category] = true;
    });
    return categories.wheel && categories.tire && categories.tpms && categories.handling;
  }

  function findBrokenItems(cart) {
    var tireSetItems = (cart.items || []).filter(isTireSetItem);
    var groups = groupItems(tireSetItems);
    var broken = [];

    Object.keys(groups).forEach(function (bundleId) {
      var items = groups[bundleId];
      var structuredResult = isStructuredBundleComplete(items);
      var complete = structuredResult === null
        ? isLegacyBundleComplete(items)
        : structuredResult;
      if (!complete) broken = broken.concat(items);
    });

    return broken;
  }

  function showRemovalNotice() {
    var existing = document.getElementById('tsb-integrity-banner');
    if (existing) existing.remove();

    var banner = document.createElement('div');
    banner.id = 'tsb-integrity-banner';
    banner.setAttribute('role', 'alert');
    banner.style.cssText =
      'position:fixed;top:20px;left:50%;transform:translateX(-50%);' +
      'z-index:99999;background:#fff;color:#222;border:2px solid #d62828;border-radius:8px;' +
      'padding:18px 24px;width:min(520px,calc(100vw - 32px));box-sizing:border-box;' +
      'box-shadow:0 8px 32px rgba(0,0,0,0.2);' +
      'font:14px/1.5 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;white-space:pre-line;';
    banner.textContent =
      'The complete tire set must stay together. Because a required item was removed, the entire tire set has been removed from your cart.\n\n' +
      'To buy wheels separately, add them with the regular Add to cart button.';
    document.body.appendChild(banner);
  }

  function removeBrokenItems(items) {
    var updates = {};
    items.forEach(function (item) {
      updates[item.key] = 0;
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not remove incomplete tire set');
      showRemovalNotice();
      setTimeout(function () {
        window.location.reload();
      }, 1800);
      return false;
    });
  }

  function readCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read cart');
      return response.json();
    });
  }

  function validateCart(fresh) {
    if (inFlight) return fresh ? inFlight.then(function () { return validateCart(true); }) : inFlight;

    inFlight = readCart()
      .then(function (cart) {
        var brokenItems = findBrokenItems(cart);
        if (brokenItems.length) return removeBrokenItems(brokenItems);
        var hasLocalServices = cart.items.some(function (item) { return /^DFW-(INSTALL|DISPOSAL)-/.test(item.sku || ''); });
        var quantityPending = hasLocalServices && Array.from(document.querySelectorAll('[data-cartitem-key]')).some(function (row) {
          var input = row.querySelector('[data-quantity-input]');
          var item = cart.items.find(function (line) { return line.key === row.dataset.cartitemKey; });
          return input && item && Number(input.value) !== item.quantity;
        });
        var serviceError = quantityPending ? 'Your cart is updating. Please wait for the totals to update, then try checkout again.' : window.AWLocalTireServices ? window.AWLocalTireServices.cartError(cart) : (hasLocalServices ? 'Service verification is unavailable. Please reload your cart before checkout.' : '');
        var notice = document.getElementById('aw-local-service-notice');
        if (serviceError) {
          if (!notice) {
            notice = document.createElement('div');
            notice.id = 'aw-local-service-notice';
            notice.setAttribute('role', 'alert');
            notice.style.cssText = 'position:fixed;bottom:20px;left:16px;right:16px;z-index:99999;padding:16px;background:#fff;border:2px solid #a5202b;color:#172b3a;max-width:600px;margin:auto;';
            document.body.appendChild(notice);
          }
          notice.textContent = serviceError + ' ';
          var link = document.createElement('a');
          link.href = '/cart'; link.textContent = 'Review cart'; notice.appendChild(link);
          return false;
        }
        if (notice) notice.remove();
        return true;
      })
      .catch(function (error) {
        console.warn('[TireSetIntegrity] validation failed:', error);
        return false;
      })
      .then(function (result) {
        inFlight = null;
        return result;
      });

    return inFlight;
  }

  function removeSelectedBundle(trigger) {
    var url = new URL(trigger.href, window.location.origin);
    var line = parseInt(url.searchParams.get('line'), 10);
    if (!line) return Promise.resolve(true);

    return readCart().then(function (cart) {
      var selectedItem = (cart.items || [])[line - 1];
      if (!isTireSetItem(selectedItem)) return true;

      var bundleId = property(selectedItem, '_tsb_bundle_id') || '__legacy__';
      var bundleItems = groupItems((cart.items || []).filter(isTireSetItem))[bundleId] || [];
      return bundleItems.length ? removeBrokenItems(bundleItems) : true;
    });
  }

  function scheduleValidation() {
    clearTimeout(scheduled);
    scheduled = setTimeout(validateCart, 150);
  }

  function continueCheckout(trigger) {
    resumingCheckout = true;
    if (trigger.tagName === 'A' && trigger.href) {
      window.location.href = trigger.href;
      return;
    }

    var form = trigger.closest('form');
    if (form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(trigger);
      } else {
        form.submit();
      }
    }
  }

  document.addEventListener('click', function (event) {
    if (resumingCheckout || !event.target || !event.target.closest) return;

    var removeTrigger = event.target.closest(REMOVE_SELECTOR);
    if (removeTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      removeTrigger.setAttribute('aria-busy', 'true');

      removeSelectedBundle(removeTrigger)
        .then(function (continueNormally) {
          removeTrigger.removeAttribute('aria-busy');
          if (continueNormally) window.location.href = removeTrigger.href;
        })
        .catch(function (error) {
          console.warn('[TireSetIntegrity] bundle removal failed:', error);
          window.location.href = removeTrigger.href;
        });
      return;
    }

    var trigger = event.target.closest(CHECKOUT_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    trigger.setAttribute('aria-busy', 'true');

    validateCart(true).then(function (valid) {
      trigger.removeAttribute('aria-busy');
      if (valid) continueCheckout(trigger);
    });
  }, true);

  document.addEventListener('submit', function (event) {
    if (resumingCheckout || !event.target || !event.target.querySelector) return;
    var trigger = event.submitter || event.target.querySelector(CHECKOUT_SELECTOR);
    if (!trigger || !trigger.matches(CHECKOUT_SELECTOR)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    trigger.setAttribute('aria-busy', 'true');

    validateCart(true).then(function (valid) {
      trigger.removeAttribute('aria-busy');
      if (valid) continueCheckout(trigger);
    });
  }, true);

  CART_EVENTS.forEach(function (eventName) {
    window.addEventListener(eventName, scheduleValidation);
  });
  window.addEventListener('pageshow', function () { resumingCheckout = false; scheduleValidation(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleValidation);
  } else {
    scheduleValidation();
  }
})();
